<template>
    <breeze-authenticated-layout>
      <template #header>
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
          Create Package สำหรับ {{vendor.name}}
        </h2>
      </template>
      <div class="py-12 max-w-7xl mx-auto sm:px-6 lg:px-8">
          <div class="bg-white overflow-hidden shadow sm:rounded-lg">
              <form @submit.prevent="doUpdate">
                <div class="px-6 py-12">
                      <div class="col-span-8 sm:col-span-2">
                          <breeze-label
                          for="code"
                          value="รหัส Package"
                          />
                          <breeze-input
                          id="code"
                          type="text"
                          class="mt-1 block w-full"
                          placeholder="เช่น HST01 HST02"
                          v-model="form.code"
                          />
                          <breeze-input-error
                          :message="form.errors.code"
                          class="mt-2"
                          />
                      </div>
                  </div>  
                <div class="px-6">
                      <div class="col-span-8 sm:col-span-2">
                          <breeze-label
                          for="name"
                          value="ชื่อ Package และรายละเอียดโดยย่อ"
                          />
                          <breeze-input
                          id="name"
                          type="text"
                          class="mt-1 block w-full"
                          placeholder="เช่น Hosting 1GB"
                          v-model="form.name"
                          />
                          <breeze-input-error
                          :message="form.errors.name"
                          class="mt-2"
                          />
                      </div>
                  </div>
  
                  <div class="md:col-span-2 p-6 text-center">
                      <button
                          class="
                          mt-4
                          px-4
                          py-2
                          bg-blue-900
                          border border-transparent
                          rounded-md
                          text-xl text-white
                          tracking-widest
                          hover:bg-yellow-600
                          active:bg-yellow-700
                          focus:outline-none
                          focus:border-yellow-700
                          focus:shadow-outline-white
                          transition
                          ease-in-out
                          duration-150
                          "
                          :class="{
                          'opacity-50': form.processing,
                          }"
                          :disabled="form.processing"
                      >
                          บันทึก
                      </button>
                  </div>
              </form>
          </div>
      </div>
    </breeze-authenticated-layout>
  </template>
  
  <script>
  import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
  import BreezeButton from "@/Components/Button";
  import BreezeSecondaryButton from "@/Components/SecondaryButton";
  import BreezeDialogModal from "@/Components/DialogModal";
  import BreezeLabel from "@/Components/Label";
  import BreezeInputError from "@/Components/InputError";
  import BreezeInput from "@/Components/Input";
  
  export default {
    props: ['vendor'],
    components: {
      BreezeAuthenticatedLayout,
      BreezeButton,
      BreezeDialogModal,
      BreezeSecondaryButton,
      BreezeLabel,
      BreezeInput,
      BreezeInputError,
    },
    data() {
      return {
        form: this.$inertia.form({
          name: "",
          vendor_id: this.vendor.id,
          code: "",
        }),
      };
    },
    methods: {
  
      doUpdate() {
        this.form.post(route("staff.packages.store"), {
          preserveScroll: true,
          onSuccess: () => this.form.reset(),
        });
      },
    },
  };
  </script>
  